import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi";
import { unSelectOpportunity } from "../../store/opportunity/opportunitySlice";

export const createReservation = async (
  formValues,
  succesMsg,
  errorMsg,
  dispatch
) => {
  try {
    const { data } = await faradayApi.post("/reservation", formValues);

    if (data.ok === true) {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: succesMsg,
        icon: "success",
      });
      dispatch(unSelectOpportunity());

      return true;
    } else {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: errorMsg,
        icon: "error",
        iconColor: "#FF7765",
      });
      return false;
    }
  } catch (error) {
    console.log(error);
    Swal.fire({
      confirmButtonColor: "#001B60",
      text: error,
      icon: "error",
      iconColor: "#FF7765",
    });
  }
};

export const editReservation = async (
  formValues,
  succesMsg,
  errorMsg,
  dispatch,
  navigate
) => {
  try {
    const { data } = await faradayApi.put("/reservation", formValues);

    if (data.ok === true) {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: succesMsg,
        icon: "success",
      });
      dispatch(unSelectOpportunity());
      navigate && navigate("/opportunities");
      return true;
    } else {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: errorMsg,
        icon: "error",
        iconColor: "#FF7765",
      });
      return false;
    }
  } catch (error) {
    console.log(error);
    Swal.fire({
      confirmButtonColor: "#001B60",
      text: error,
      icon: "error",
      iconColor: "#FF7765",
    });
  }
};

export const editReservationByAdmin = async (
  formValues,
  succesMsg,
  errorMsg,
  dispatch,
  navigate
) => {
  try {
    const { data } = await faradayApi.put(
      "/reservation/actualReservation",
      formValues
    );

    if (data.ok === true) {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: succesMsg,
        icon: "success",
      });
      dispatch(unSelectOpportunity());
      navigate && navigate("/opportunities");
      return true;
    } else {
      Swal.fire({
        confirmButtonColor: "#001B60",
        text: errorMsg,
        icon: "error",
        iconColor: "#FF7765",
      });
      return false;
    }
  } catch (error) {
    console.log(error);
    Swal.fire({
      confirmButtonColor: "#001B60",
      text: error,
      icon: "error",
      iconColor: "#FF7765",
    });
  }
};

export const deleteReservation = async (
  e,
  succesMsg,
  errorMsg,
  cancelButton,
  confirmButton,
  deleteConfirm
) => {
  const { value } = await Swal.fire({
    text: `${deleteConfirm} ${e.row.whoInvests}`,
    showCancelButton: true,
    confirmButtonColor: "#001B60",
    cancelButtonText: cancelButton,
    confirmButtonText: confirmButton,
    reverseButtons: true,
  });
  value && onConfirm(e.row.id, succesMsg, errorMsg, e.row.whoInvests);
};

const onConfirm = async (id, succesMsg, errorMsg, whoInvests) => {
  const { data } = await faradayApi.delete("/reservation", { data: { id } });

  data.data !== 0 && !data.error
    ? Swal.fire({
        confirmButtonColor: "#001B60",
        text: `${whoInvests} ${succesMsg}`,
        icon: "success",
      })
    : Swal.fire({
        confirmButtonColor: "#001B60",
        text: errorMsg,
        icon: "error",
      });
};
